<ng-container *transloco="let t">
  <span> {{ title }} <br/>
    @if (details) {
      <span> {{ t(details) || t('messages.error.generic') }} </span>
    }
  </span>
</ng-container>
